
    /**
     * @author tribes agency
     * @description component created by Tribes
     * ============================================================================================
     */
export default {
    name: "TribesReviewsNoname",
    // props: {
    //     companies: {
    //         default: () => ([
    //             'logo-frame.png',
    //             'logo-frame-1.png',
    //             'logo-frame-2.png',
    //             'logo-frame-3.png',
    //             'logo-frame-4.png',
    //             'logo-frame-5.png',
    //         ]),
    //         type: Array
    //     },
    //     reviews: {
    //         default: () => ([
    //             {
    //                 star: 4,
    //                 quote: 'Lorem ipsum dolor sit amet consectetur. Hac accumsan urna habitasse felis consectetur tempus quis. Tempus morbi tincidunt sed ornare et. Ipsum in libero.',
    //                 name: 'Example person’s name',
    //                 position: 'Job title example',
    //                 image: 'user_customer.png'
    //             },
    //             {
    //                 star: 2.5,
    //                 quote: 'Lorem ipsum dolor sit amet consectetur. Hac accumsan urna habitasse felis consectetur tempus quis. Tempus morbi tincidunt sed ornare et. Ipsum in libero.',
    //                 name: 'Example person’s name',
    //                 position: 'Job title example',
    //                 image: 'user_customer.png'
    //             },
    //             {
    //                 star: 5,
    //                 quote: 'Lorem ipsum dolor sit amet consectetur. Hac accumsan urna habitasse felis consectetur tempus quis. Tempus morbi tincidunt sed ornare et. Ipsum in libero.',
    //                 name: 'Example person’s name',
    //                 position: 'Job title example',
    //                 image: 'user_customer.png'
    //             },
    //             {
    //                 star: 3,
    //                 quote: 'Lorem ipsum dolor sit amet consectetur. Hac accumsan urna habitasse felis consectetur tempus quis. Tempus morbi tincidunt sed ornare et. Ipsum in libero.',
    //                 name: 'Example person’s name',
    //                 position: 'Job title example',
    //                 image: 'user_customer.png'
    //             }
    //         ]),
    //         type: Array
    //     },
    //     title: {
    //         default: "Trusted by thousands<br>of happy customers",
    //         type: String
    //     }
    // },
    data() {
        return {
            swiper: {
                review: {},
                company: {},
            },
        }
    },
    mounted() {
        this.swiper.review = new Swiper(".comments-slider .swiper", {
            spaceBetween: 10,
            loop: true,
            navigation: {
                nextEl: '.comments-slider .next-slide',
                prevEl: '.comments-slider .prev-slide',
            },
            breakpoints: {
                640: {slidesPerView: 1},
                768: {slidesPerView: 2},
                1024: {slidesPerView: 2},
                1280: {slidesPerView: 3},
            }
        });

        this.swiper.company = new Swiper(".customers-slider .swiper", {
            spaceBetween: 20,
            loop: true,
            autoplay: {
                delay: 2500,
                disableOnInteraction: true
            },
            breakpoints: {
                360: {slidesPerView: 2},
                640: {slidesPerView: 3},
                768: {slidesPerView: 4},
                1024: {slidesPerView: 5},
                1280: {slidesPerView: 6},
            }
        });
    },
}
